var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_541_4729)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8684 7.75686C15.0573 8.60282 16.4812 9.0548 17.9399 9.04932V6.15575C17.6531 6.15654 17.3671 6.12581 17.087 6.06412V8.36933C15.625 8.37193 14.1991 7.91476 13.0107 7.0624V13.0135C13.0071 13.99 12.7396 14.9474 12.2364 15.784C11.7333 16.6207 11.0133 17.3055 10.1528 17.7658C9.29231 18.2261 8.32341 18.4447 7.34884 18.3985C6.37427 18.3523 5.43036 18.043 4.61719 17.5034C5.36935 18.2651 6.33043 18.7863 7.37872 19.0009C8.42701 19.2156 9.51537 19.114 10.506 18.7092C11.4966 18.3043 12.3449 17.6143 12.9434 16.7266C13.542 15.8389 13.8639 14.7934 13.8684 13.7224V7.75686ZM14.9236 4.80541C14.319 4.14949 13.948 3.31191 13.8684 2.42304V2.04688H13.0589C13.159 2.61188 13.3767 3.14949 13.698 3.62475C14.0192 4.10001 14.4368 4.50228 14.9236 4.80541ZM6.49152 15.2126C6.21096 14.8454 6.03902 14.4068 5.99528 13.9466C5.95154 13.4864 6.03775 13.0231 6.2441 12.6095C6.45045 12.196 6.76866 11.8487 7.1625 11.6072C7.55634 11.3657 8.01001 11.2397 8.47186 11.2436C8.72685 11.2435 8.98034 11.2826 9.22352 11.3594V8.36933C8.93925 8.33165 8.65255 8.31553 8.36585 8.32111V10.6456C7.77374 10.4583 7.13286 10.5009 6.5707 10.7649C6.00854 11.029 5.56627 11.4952 5.33188 12.0707C5.09748 12.6463 5.08813 13.2891 5.30568 13.8713C5.52322 14.4534 5.95173 14.9323 6.50598 15.2126H6.49152Z",
    fill: "#EE1D52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0102 7.04311C14.1986 7.89547 15.6245 8.35263 17.0865 8.35004V6.04483C16.2535 5.86855 15.4968 5.43504 14.9231 4.80541C14.4363 4.50228 14.0187 4.10001 13.6974 3.62475C13.3762 3.14949 13.1584 2.61188 13.0584 2.04688H10.9287V13.7224C10.9267 14.2392 10.763 14.7424 10.4607 15.1614C10.1584 15.5804 9.73262 15.8941 9.24309 16.0585C8.75357 16.2228 8.2249 16.2297 7.7313 16.078C7.2377 15.9263 6.80396 15.6237 6.49096 15.2126C5.99493 14.9621 5.59768 14.5517 5.36331 14.0475C5.12895 13.5433 5.07113 12.9747 5.19919 12.4336C5.32725 11.8925 5.63372 11.4103 6.06915 11.0649C6.50458 10.7195 7.04358 10.531 7.59918 10.5299C7.8541 10.5307 8.10746 10.5697 8.35084 10.6456V8.3211C7.29928 8.34637 6.27797 8.67839 5.41229 9.27642C4.5466 9.87445 3.87421 10.7125 3.47766 11.6876C3.0811 12.6627 2.97764 13.7325 3.17997 14.7656C3.3823 15.7987 3.88162 16.7503 4.61663 17.5034C5.42996 18.0469 6.37536 18.3594 7.35213 18.4076C8.32889 18.4558 9.30043 18.238 10.1633 17.7772C11.0261 17.3165 11.7479 16.6301 12.2518 15.7912C12.7557 14.9523 13.0228 13.9923 13.0246 13.0135L13.0102 7.04311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0867 6.04471V5.42259C16.3218 5.42584 15.5716 5.21179 14.9233 4.80529C15.4956 5.43673 16.2529 5.8706 17.0867 6.04471ZM13.0586 2.04676C13.0586 1.93584 13.0249 1.82009 13.0104 1.70917V1.33301H10.0712V13.0134C10.0687 13.6674 9.80699 14.2937 9.34357 14.7548C8.88016 15.216 8.25289 15.4742 7.59943 15.4729C7.21467 15.4749 6.83492 15.3856 6.49122 15.2125C6.80421 15.6235 7.23795 15.9261 7.73155 16.0778C8.22515 16.2295 8.75382 16.2227 9.24335 16.0583C9.73288 15.894 10.1587 15.5803 10.461 15.1613C10.7633 14.7423 10.9269 14.2391 10.9289 13.7223V2.04676H13.0586ZM8.35109 8.31616V7.65546C7.14164 7.49102 5.91219 7.74142 4.86312 8.36586C3.81405 8.99031 3.00722 9.95197 2.57413 11.0941C2.14103 12.2363 2.1072 13.4916 2.47815 14.6555C2.84911 15.8193 3.60297 16.8231 4.61688 17.5033C3.88743 16.7484 3.39344 15.7972 3.19524 14.766C2.99704 13.7347 3.10322 12.668 3.50081 11.6962C3.8984 10.7243 4.57019 9.88944 5.4341 9.29347C6.29801 8.69751 7.31664 8.36629 8.36555 8.34028L8.35109 8.31616Z",
    fill: "#69C9D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_541_4729",
    x: 0,
    y: 0,
    width: 20,
    height: 20.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_541_4729"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.5023efc782944a87ea56aeaf85cde2f5.svg";
export { ForwardRef as ReactComponent };